export enum Enrollment {
  AUTHENTICATION_SUCCESSFUL = "Y",
  AUTHENTICATION_ATTEMPTED = "A",
  AUTHENTICATION_FAILED = "N",
  AUTHENTICATION_UNAVAILABLE = "U",
  ERROR = "E",
}
